module.exports = __webpack_public_path__ + "static/media/DubaiW23-Light.a7568628.eot";